import React, { useEffect } from 'react';

import { useAppDispatch } from '../../redux/hooks';
import { setPageTitle } from '../../redux/slices/PageTitleSlice';

import OCPIConnections from './components/OCPIConnections';

/**
 * OCPI Management Dashboard component.
 * Renders the OCPI Connections dashboard directly.
 */
function OCPIManagement(): JSX.Element {
  const dispatch = useAppDispatch();
  // const [platformName, setPlatformName] = useState('');
  // const [isEditingPlatform, setIsEditingPlatform] = useState(false);

  useEffect(() => {
    dispatch(setPageTitle('OCPI Network Board'));

    // Generate random 5 letter string for platform name
    // const randomString = Math.random().toString(36).substring(2, 7).toUpperCase();
    // setPlatformName(`Energic-${randomString} (OCPI-${randomString})`);
  }, [dispatch]);

  return (
    <div className="ocpi-stepper-page">
      {/* ── Partner & Platform Configuration ───────────────────────────── */}
      {/* <div className="ocpi-platform-config">
        <div className="ocpi-platform-config__grid">
          <div className="ocpi-platform-config__field">
            <label htmlFor="platform-input">
              PLATFORM
              <input
                id="platform-input"
                type="text"
                className="ocpi-platform-config__input"
                value={platformName}
                onChange={(event) => setPlatformName(event.target.value)}
                disabled={!isEditingPlatform}
              />
            </label>
          </div>
          <div className="ocpi-platform-config__actions">
            <button
              className={`ocpi-platform-config__btn ocpi-platform-config__btn--${
                isEditingPlatform ? 'primary' : 'edit'
              }`}
              type="button"
              onClick={() => setIsEditingPlatform(!isEditingPlatform)}>
              {isEditingPlatform ? 'Save' : 'Edit'}
            </button>
          </div>
        </div>
      </div> */}

      {/* ── Connections Dashboard ───────────────────────────────────────── */}
      <div className="ocpi-stepper-page__content">
        <OCPIConnections />
      </div>
    </div>
  );
}

export default OCPIManagement;
